import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  filterButtonWrapper: {
    display: 'flex',
    marginBottom: theme.app.spacing.sm,
    position: 'relative',
    flexDirection: 'column',

    '& .select-input__label': {
      color: theme.app.colors.text.primary,
      fontSize: theme.app.typography.label.fontSize
    },
    '& .select-input__input': {
      padding: theme.app.spacing.sm,
      height: 24,
      borderRadius: theme.app.borderRadius.sm,
      margin: `${theme.app.spacing.sm}px 0`,
      width: 'calc(100% - 16px)',
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      border: 'none',
      background: `${theme.app.colors.input.background} no-repeat calc(100% - 16px) center`,
      backgroundImage: `url(${require('../../assets/png/select.png')})`,
      transition: 'background-image 0.2s',

      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&.select-input__input--error': {
        border: `1px solid ${theme.app.indication.danger}`,
        backgroundColor: theme.app.colors.input.backgroundError
      },
      '&.select-input__input--loading': {
        backgroundImage: 'none !important',
        cursor: 'wait'
      }
    },

    '& .select-input__error': {
      top: 67,
      left: 0,
      display: 'block',
      width: '100%',
      position: 'absolute',
      color: theme.app.indication.danger,
      fontSize: theme.app.typography.error.fontSize,

      whiteSpace: 'normal',
      wordBreak: 'break-word'
    }

    // '& .select-input__dropper': {
    //   position: 'absolute',
    //   top: 50,
    //   left: 0,
    //   zIndex: 100,
    //   overflowY: 'auto',
    //   width: '100%',
    //   maxHeight: 'min(220px, calc(100vh - 180px))',
    //   borderRadius: 4,
    //   color: '#030A15',
    //   border: 'none',
    //   padding: 0,
    //   margin: 0,
    //   '& li': {
    //     height: 32,
    //     display: 'flex',
    //     padding: 0,
    //     margin: 0,
    //     cursor: 'pointer',
    //     alignItems: 'center',
    //     backgroundColor: '#F2F0EE',
    //     zIndex: 1,
    //     fontSize: theme.app.typography.paragraph.fontSize,
    //     width: '100%',
    //     position: 'relative',
    //     '& > *': {
    //       padding: '0 8px',
    //       width: '100%',
    //       height: '100%',
    //       display: 'flex',
    //       alignItems: 'center'
    //     },
    //     '&:hover': {
    //       color: '#030A15',
    //       backgroundColor: '#D4C7BC'
    //     }
    //   },
    //   '& .item-selected': {
    //     color: theme.palette.background.primary.contrastText,
    //     backgroundColor: theme.palette.background.primary.main
    //   },

    //   '& .highlighted': {
    //     color: '#030A15',
    //     backgroundColor: '#D4C7BC'
    //   }
    // }
  },

  selectInputDropper: {
    zIndex: 1600,
    overflowY: 'auto',
    maxHeight: 'min(220px, calc(100vh - 180px))',
    borderRadius: theme.app.borderRadius.sm,
    color: theme.app.colors.text.primary,
    backgroundColor: theme.app.colors.dropdown.background,
    padding: 0,
    margin: 0,
    boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',

    '& li': {
      padding: 6,
      height: 32,
      display: 'flex',

      margin: 0,
      cursor: 'pointer',
      alignItems: 'center',
      backgroundColor: theme.app.colors.dropdown.background,
      fontSize: theme.app.typography.paragraph.fontSize,
      width: '100%',

      '& > *': {
        padding: `0 ${theme.app.spacing.sm}px`,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center'
      },

      '&:hover': {
        backgroundColor: theme.app.colors.dropdown.hover
      }
    },

    '& .highlighted': {
      backgroundColor: theme.app.colors.dropdown.hover
    }
  },
  hoverSelect: {
    color: theme.palette.background.primary.contrastText,
    backgroundColor: theme.palette.background.primary.main
  },

  ulHidden: {
    display: 'none'
  },

  loadingWrapper: {
    left: '50%',
    transform: 'translateX(-50%)',

    '& img': {
      width: '24px'
    }
  },

  inputLoading: {
    position: 'absolute',
    right: '24px',
    top: '59%',
    transform: 'translateY(-50%)',
    pointerEvents: 'none'
  },

  loadingItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,

    '& img': {
      width: '24px'
    },

    '& > div': {
      position: 'static !important', // 🔥 mata o absolute
      height: 'auto',
      opacity: 1
    }
  }
}))
